import * as React from 'react'
import { Row } from 'antd'
import { useIntl } from 'react-intl'
import { DeliveryStatus, IncompleteDeliveryStatuses } from '../../store/DeliveryTracking/types'
import styles from './DeliveryIncomplete.module.scss'

const DeliveryIncomplete = (props: IncompleteProps) => {
  const { status, show } = props
  const { formatMessage } = useIntl()
  const translate = (id: string, values: any = {}) => formatMessage({ id }, values)

  const valid = IncompleteDeliveryStatuses.includes(status)
  const messageId = `order_status_${status}`

  return (
    (show && valid) ? <Row className={styles.title}>{translate(messageId)}</Row> : null
  )
}

interface IncompleteProps {
  status: DeliveryStatus
  show: boolean
}

export default DeliveryIncomplete
